import { api, Env } from "@ancademy/vse-client";
import { FormOutlined } from "@ant-design/icons";
import { KnowledgePoints, Style } from "@client";
import { useAsyncEffect } from "@client/util";
import { css } from "@emotion/css";
import { TSubGameList } from "@share";
import { Button, Col, Row, Space } from "antd";
import { sum } from "lodash";
import React, { useState } from "react";
import { Process } from "./Process";
import { ReportModal } from "./Report";

export function Header({ gameId, subGameList }: { gameId: string; subGameList: TSubGameList }) {
  const [score, setScore] = useState(0);
  useAsyncEffect(async () => {
    const result = await api.getMyResult(gameId);
    setScore(sum(result.steps.map((s) => s?.score || 0)));
  });
  return (
    <>
      <Row className={Style.header}>
        <Col span={4}>
          <Button onClick={() => (location.href = `${Env.basePath}`)} className={Style.btnPrimarySm}>
            主页
          </Button>
        </Col>
        <Col
          span={16}
          className={css`
            display: flex;
            justify-content: center;
            gap: 1rem;
            align-items: baseline;
          `}
        >
          <Process subGameList={subGameList} />
          <div
            className={css`
              font-size: 1.5rem;
            `}
          >
            得分：{score}
          </div>
        </Col>
        <Col
          span={4}
          className={css`
            text-align: right;
          `}
        >
          <Space size="large">
            <KnowledgePoints />
            <ReportModal gameId={gameId} allSubGameOver={subGameList.every((s) => s.over)}>
              <Button className={Style.btnPrimarySm} icon={<FormOutlined />}>
                实验报告
              </Button>
            </ReportModal>
          </Space>
        </Col>
      </Row>
    </>
  );
}
